import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { replaceDistressedCategories, setTextFilter, setPageSize, setPageNumber } from '../../stores/distressedCategories/actions'
import CategoryService from '../../services/categoryService';


const GetPath = (category) =>
    category.parent
        ? `${GetPath(category.parent)} / ${category.description}`
        : category.description

const MapCategories = (categories) => {
    const MapCategory = (category) => ({
        ...category,
        path: GetPath(category)
    })

    return categories
        .map(MapCategory).sort((a, b) => {
            if (a.path < b.path) {
                return -1;
            }
            if (a.path > b.path) {
                return 1;
            }
            return 0;
        });
}

const useDistressedCategories = () => {
    const { distressedCategories, pageSize, pageNumber, totalResults, totalPage, filters: { textFilter } } = useSelector(state => state.distressedCategories_data);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const [loadingChildren, setLoadingChildren] = useState(false);

    useEffect(() => {
        const search = () => {
            setLoading(true);
            CategoryService
                .SeachDistressedCategories(textFilter, pageSize, pageNumber)
                .then(result => dispatch(replaceDistressedCategories(MapCategories(result.values), result.totalResults, result.totalPage)))
                .finally(() => setLoading(false));
        }

        search();
    }, [dispatch, pageNumber, pageSize, textFilter]);

    const ChangeTextFilter = value =>
        dispatch(setTextFilter(value));

    const ChangePageSize = (pageSize = 10) => {
        if (pageSize < 1)
            pageSize = 1;

        dispatch(setPageSize(pageSize));
    }

    const ChangePageNumber = (pageNumber = 1) => {
        if (pageNumber < 1)
            pageNumber = 1;

        dispatch(setPageNumber(pageNumber));
    }

    const findChildren = async (category) => {
        if (category.level < 4) {
            setLoadingChildren(true);
            const result = await CategoryService.SeachDistressedCategories(category.description, 9999999, 1);
            setLoadingChildren(false);
            return result.values.filter(i => i.id !== category.id);
        }

        return [];
    };

    return {
        distressedCategories,
        loading,
        textFilter,
        pageSize,
        pageNumber,
        totalResults,
        totalPage,
        ChangePageNumber,
        ChangePageSize,
        ChangeTextFilter,
        GetPath,
        findChildren,
        loadingChildren
    }
}

export default useDistressedCategories;